import { useGamificationBalance } from "../providers/GamificationBalanceProvider";
import { useSchool } from "../lib/hooks";

import { Image } from "./Image";

/** `iconSize` sizes the points icon itself (antd wraps it in a box of the same size — never shrink only the img). */
export const GamificationBalance: React.FC<{ iconSize?: number }> = ({ iconSize = 30 }) => {
  const gamificationBalance = useGamificationBalance();
  const school = useSchool();

  const gamification = school.gamification;
  if (!gamification) return null;

  return (
    <div className="flex gap-5 align-center">
      <Image
        disablePreview
        fit="contain"
        cloudKey={gamification.pointsIconCloudKey}
        width={iconSize}
        height={iconSize}
        resize={{ h: iconSize * 2, w: iconSize * 2 }}
      />
      {gamificationBalance}
      <span>{gamification.pointsShortName}</span>
    </div>
  );
};
